import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';
import { PwTranslateLoader } from '@pw-translate-loader';
import { LanguageSelectComponent } from './components/language-select/language-select.component';

@NgModule({
  declarations: [LanguageSelectComponent],
  exports: [LanguageSelectComponent],
  imports: [CommonModule, TranslateModule, MatRippleModule],
})
export class PwLanguageSelectModule {
  constructor(private _translateLoader: PwTranslateLoader) {
    this._translateLoader.addModule({ name: 'languages', relateLocation: 'shared/languages' });
  }
}
